export default __webpack_public_path__ + "static/media/Karthick Thangamaligai.7705278c.png";